import { Skeleton } from '../../../shared/components/Skeleton';
import { SkeletonFields } from '../../../shared/components/SkeletonFields';
import { SkeletonRegion } from '../../../shared/components/SkeletonRegion';

/**
 * The start step's shape while the page asks which channels can send a code: whether a code or only the password is
 * on offer isn't known yet, and showing the password form first would swap it out a moment later.
 */
export function LoginStartSkeleton({ title }: { title: string }) {
  return (
    <>
      <h1 className="text-2xl font-semibold tracking-tight text-fg">{title}</h1>
      <SkeletonRegion label="Loading sign-in" className="mt-3">
        <Skeleton className="mb-8 h-4 w-full" />
        <SkeletonFields count={1} />
        <Skeleton className="mt-8 h-10 w-full" />
        <Skeleton className="mt-12 h-10 w-full" />
      </SkeletonRegion>
    </>
  );
}
